import { render } from "./playerComponent.vue?vue&type=template&id=35ad6dce&scoped=true"
import script from "./playerComponent.vue?vue&type=script&lang=js"
export * from "./playerComponent.vue?vue&type=script&lang=js"

import "./playerComponent.vue?vue&type=style&index=0&id=35ad6dce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ad6dce"]])

export default __exports__